import React from 'react';
import {
  CheckOutlined,
  CloseOutlined,
  RightOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';

function Fact({ children }) {
  if (children == null || children === '') return null;
  return <span className="listing-card__fact">{children}</span>;
}

function isOrgActive(record) {
  return parseInt(record?.org_status, 10) === 1;
}

function formatCount(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n.toLocaleString() : '0';
}

export default function OrganizationListingCard({
  record,
  onOpen,
  onOpenStaffUploads,
}) {
  const name = record?.org_name || '—';
  const code = record?.org_social_no || record?.org_code || '—';
  const orgId = record?.org_id ?? record?.hash ?? '—';
  const location = [record?.org_city, record?.org_state].filter(Boolean).join(', ');
  const active = isOrgActive(record);
  const pendingUploads = Number(record?.pending_staff_uploads_count) || 0;

  return (
    <article
      className="listing-card listing-card--linear org-listing-card"
      onClick={() => onOpen?.(record)}
      onKeyDown={onOpen ? (e) => e.key === 'Enter' && onOpen(record) : undefined}
      role={onOpen ? 'button' : undefined}
      tabIndex={onOpen ? 0 : undefined}
    >
      <div className="listing-card__lead">
        <div className="listing-card__icon is-org" aria-hidden>
          <TeamOutlined />
        </div>
        <div className="listing-card__identity">
          <h3 className="listing-card__title">
            {name}
            {(record?.enrollment_segment_label || record?.enrollment_segment) ? (
              <Tag color="geekblue" style={{ marginLeft: 8, marginRight: 0 }}>
                {record.enrollment_segment_label || String(record.enrollment_segment).toUpperCase()}
              </Tag>
            ) : null}
            {pendingUploads > 0 && onOpenStaffUploads ? (
              <Tooltip title={`${pendingUploads} staff upload${pendingUploads === 1 ? '' : 's'} awaiting review`}>
                <Tag
                  color="gold"
                  className="orgs-staff-upload-badge"
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpenStaffUploads(record);
                  }}
                >
                  {pendingUploads} pending
                </Tag>
              </Tooltip>
            ) : null}
          </h3>
          <p className="listing-card__meta">{code} · ID {orgId}</p>
        </div>
      </div>

      <div className="listing-card__facts">
        <Fact>{location || '—'}</Fact>
        <Fact>{formatCount(record?.active_policies)} active policies</Fact>
        <Fact>{formatCount(record?.active_enrollees)} active enrollees</Fact>
        {record?.org_email ? <Fact>{record.org_email}</Fact> : null}
      </div>

      <div className="listing-card__aside org-listing-card__aside">
        <span className={`listing-card__status ${active ? 'is-active' : 'is-inactive'}`}>
          {active ? <CheckOutlined /> : <CloseOutlined />}
          {active ? 'Active' : 'Inactive'}
        </span>
        {onOpen ? <RightOutlined className="listing-card__chevron" aria-hidden /> : null}
      </div>
    </article>
  );
}
